import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export interface UseMeetTimerResult {
	remainingTime: string;
	isLessThanTwoMinutes: boolean;
	hasEnded: boolean;
}

export function useMeetTimer(startDate?: string, durationInMinutes?: number): UseMeetTimerResult {
	const [remainingTime, setRemainingTime] = useState('00:00');
	const [isLessThanTwoMinutes, setIsLessThanTwoMinutes] = useState(false);
	const [hasEnded, setHasEnded] = useState(false);

	useEffect(() => {
		if (!startDate || !durationInMinutes) {
			return;
		}

		const updateTimer = () => {
			const now = dayjs();
			const start = dayjs(startDate);
			const end = start.add(durationInMinutes, 'minute');
			
			const millisRemaining = end.diff(now);

			if (millisRemaining <= 0) {
				setRemainingTime('00:00');
				setIsLessThanTwoMinutes(true);
				setHasEnded(true);
				return;
			}

			const totalSeconds = Math.floor(millisRemaining / 1000);
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;

			const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
			setRemainingTime(formatted);

			setIsLessThanTwoMinutes(totalSeconds <= 120);
		};

		updateTimer();

		const interval = setInterval(updateTimer, 1000);

		return () => clearInterval(interval);
	}, [startDate, durationInMinutes]);

	return {
		remainingTime,
		isLessThanTwoMinutes,
		hasEnded,
	};
}

